export const baSvgIcons = {
    gear: `
    <svg viewBox="0 0 24 24">
        <path d="M8.88045214,18.2681738 C8.62157874,18.1390881 8.37182642,17.9944375 8.13242084,17.8354476 L4.33974596,
        18.7320508 L2.33974596,15.2679492 L5.01306212,12.43117 C5.0043961,12.2885575 5,12.1447922 5,12 C5,11.8552078 5.0043961,
        11.7114425 5.01306212,11.56883 L2.33974596,8.73205081 L4.33974596,5.26794919 L8.13242084,6.16455237 C8.37182642,
        6.00556249 8.62157874,5.86091189 8.88045214,5.73182621 L10,2 L14,2 L15.1195479,5.73182621 C15.3784213,5.86091189 15.6281736,
        6.00556249 15.8675792,6.16455237 L19.660254,5.26794919 L21.660254,8.73205081 L18.9869379,11.56883 C18.9956039,11.7114425 19,
        11.8552078 19,12 C19,12.1447922 18.9956039,12.2885575 18.9869379,12.43117 L21.660254,15.2679492 L19.660254,
        18.7320508 L15.8675792,17.8354476 C15.6281736,17.9944375 15.3784213,18.1390881 15.1195479,18.2681738 L14,22 L10,22 L8.88045214,
        18.2681738 Z M12,16 C14.209139,16 16,14.209139 16,12 C16,9.790861 14.209139,8 12,8 C9.790861,8 8,9.790861 8,12 C8,
        14.209139 9.790861,16 12,16 Z"></path>
    </svg>
    `,
    dashboardIcon: `
    <svg viewBox="0 0 24 24">
        <path d="M2,2 L11,2 L11,9 L2,9 L2,2 Z M13,15 L22,15 L22,22 L13,22 L13,15 Z M2,11 L11,11 L11,22 L2,22 L2,11 Z M13,
        2 L22,2 L22,13 L13,13 L13,2 Z"></path>
    </svg>
    `,
    salesMovement: `
    <svg width="24px" height="24px" viewBox="0 0 24 24">
        <g stroke="none" stroke-width="1">
            <path d="M18.8768513,5.53736225 L12,12.4142136 L9,9.41421356 L4.20710678,14.2071068 L2.79289322,12.7928932 L9,
            6.58578644 L12,9.58578644 L17.4626389,4.12314752 L15.3394949,2 L20.9963492,2 L20.9963492,7.65686365 L18.8768513,
            5.53736225 Z M3,17 L5,17 L5,22 L3,22 L3,17 Z M7,14 L9,14 L9,22 L7,22 L7,14 Z M11,16 L13,16 L13,22 L11,22 L11,16 Z M15,
            13 L17,13 L17,22 L15,22 L15,13 Z M19,10 L21,10 L21,22 L19,22 L19,10 Z"></path>
        </g>
    </svg>
    `,
    avatar: `
    <svg viewBox="3 3 42 42">
        <path d="M24 4c-11.05 0-20 8.95-20 20s8.95 20 20 20 20-8.95 20-20-8.95-20-20-20zm0 6c3.31 0 6 2.69 6 6 0 3.32-2.69 6-6
        6s-6-2.68-6-6c0-3.31 2.69-6 6-6zm0 28.4c-5.01 0-9.41-2.56-12-6.44.05-3.97 8.01-6.16 12-6.16s11.94 2.19 12 6.16c-2.59 3.88-6.99
        6.44-12 6.44z" />
        <path d="M0 0h48v48h-48z" fill="none" />
    </svg>
    `,
    question: `
    <svg viewBox="0 0 20 20">
    <defs>
        <path d="M10,2 C12.1217319,2 14.1565632,2.84285472 15.6568542,4.34314575 C17.1571453,5.84343678 18,7.87826808 18,
        10 C18,14.418278 14.418278,18 10,18 C5.581722,18 2,14.418278 2,10 C2,5.581722 5.581722,2 10,2 Z M10.7186275,14.9035578 C10.9331448,
        14.6970257 11.048089,14.4102012 11.034629,14.1150278 C11.0340966,13.5621752 10.6348082,13.0876944 10.083375,
        12.9846374 C9.53194184,12.8815805 8.98396167,13.1790269 8.77788171,13.6932658 C8.57180176,14.2075047 8.76577159,
        14.7934335 9.23999025,15.0891667 C9.71420892,15.3849 10.3348662,15.3069907 10.7186275,14.9035578 Z M11.9615665,
        9.64323215 C12.3359883,9.2888493 12.6522493,8.87932633 12.8990375,8.42931084 C13.0688222,8.05456093 13.1481414,
        7.64615666 13.1307718,7.23614032 C13.1745151,6.45995042 12.8748628,5.70313513 12.3091681,5.16106115 C11.6657794,
        4.6301641 10.8400571,4.36276544 10.0023576,4.41403265 C9.16429802,4.37619762 8.34311621,4.65447696 7.70608045,
        5.19218734 C7.11982654,5.76645141 6.80627718,6.55739995 6.84234318,7.37102046 L8.90688593,7.37102046 C8.89418192,
        7.03689059 9.01091153,6.71049907 9.23342075,6.45798563 C9.44663163,6.23058699 9.75178561,6.10883423 10.0655579,
        6.12597296 C10.7502277,6.12597296 11.118896,6.5306134 11.118896,7.35026967 C11.1177497,7.62317955 11.0451922,
        7.89118928 10.9082284,8.12842436 C10.6745612,8.48424122 10.3908464,8.8056197 10.0655579,9.08296078 C9.68547628,
        9.40558114 9.38626203,9.81038617 9.19128722,10.2657559 C9.0121094,10.7900538 8.9300492,11.3418025 8.94901945,
        11.894693 L10.7818278,11.894693 L10.7818278,11.448551 C10.8349634,10.9769384 11.0505884,10.5375088 11.3927639,
        10.2035035 L11.9615665,9.64323215 Z" id="path-1"></path>
    </defs>
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <mask id="mask-2" fill="white">
            <use xlink:href="#path-1"></use>
        </mask>
        <g id="Combined-Shape" fill-rule="nonzero"></g>
        <g mask="url(#mask-2)" fill="#7E8F9A" fill-opacity="1">
            <rect id="Rectangle-2" x="0" y="0" width="20" height="20"></rect>
        </g>
    </g>
    </svg>
    `,
    hamburgerIcon: `
    <svg stroke="#000" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" viewBox="0 0 24 24" width="20" height="20">
        <line x1="3" x2="21" y1="12" y2="12" />
        <line x1="3" x2="21" y1="6" y2="6" />
        <line x1="3" x2="21" y1="18" y2="18" />
    </svg>
    `,
    toggle: `
    <svg viewBox="0 0 16 16">
       <g><circle cx="2" cy="8" r="2"/><circle cx="8" cy="8" r="2"/><circle cx="14" cy="8" r="2"/></g>
    </svg>
    `,
    leftArrow: `
    <svg viewBox="0 0 451.847 451.847">
        <path d="M97.141,225.92c0-8.095,3.091-16.192,9.259-22.366L300.689,9.27c12.359-12.359,32.397-12.359,44.751,0
       c12.354,12.354,12.354,32.388,0,44.748L173.525,225.92l171.903,171.909c12.354,12.354,12.354,32.391,0,44.744
       c-12.354,12.365-32.386,12.365-44.745,0l-194.29-194.281C100.226,242.115,97.141,234.018,97.141,225.92z"/>
    </svg>
    `,
    rightArrow: `
    <svg viewBox="0 0 24 24">
        <g>
            <polygon points="7.93933983 6.70776695 9.35355339 5.29355339 16.0606602 12.0006602 9.35355339
             18.707767 7.93933983 17.2935534 13.232233 12.0006602"></polygon>
        </g>
    </svg>
    `,
    critical: `
    <svg viewBox="0 0 20 20">
        <defs>
            <path d="M9.29289266,1.70710623 L1.70709213,9.29289266 C1.31656753,9.68341665 1.31656703,10.3165816 1.70709102,
            10.7071062 C1.70709139,10.7071066 1.70709176,10.707107 1.70709213,10.7071073 L9.29289322,18.2928932 C9.6834176,
            18.683417 10.3165822,18.6834167 10.7071062,18.2928927 L18.2928932,10.7071068 C18.6834175,10.3165825 18.6834175,
            9.68341751 18.2928932,9.29289322 L10.7071062,1.70710734 C10.3165822,1.31658326 9.6834176,1.31658301 9.29289322,
            1.70710678 Z M10,15 C9.44771525,15 9,14.5522848 9,14 C9,13.4477153 9.44771525,13 10,13 C10.5522848,13 11,
            13.4477153 11,14 C11,14.5522848 10.5522848,15 10,15 Z M11,10.6 C11,11.3731987 10.5522848,12 10,12 C9.44771525,
            12 9,11.3731987 9,10.6 L9,6.40000001 C9,5.62680135 9.44771525,5 10,5 C10.5522848,5 11,5.62680135 11,
            6.40000001 L11,10.6 Z" id="path-1"></path>
        </defs>
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <mask id="mask-2" fill="white">
                <use xlink:href="#path-1"></use>
            </mask>
            <g fill-rule="nonzero"></g>
            <g mask="url(#mask-2)" fill="#e02d4d" fill-opacity="1">
                <rect id="Rectangle-2" x="0" y="0" width="20" height="20"></rect>
            </g>
        </g>
    </svg>
    `,
    resize: `
    <svg viewBox="0 0 24 24">
        <g>
            <path d="M20,12 L22,12 L22,14 L20,14 L20,12 Z M16,12 L18,12 L18,14 L16,14 L16,12 Z M12,12 L14,12 L14,14 L12,14 L12,12 Z M20,
            16 L22,16 L22,18 L20,18 L20,16 Z M16,16 L18,16 L18,18 L16,18 L16,16 Z M12,16 L14,16 L14,18 L12,18 L12,16 Z M8,16 L10,16 L10,
            18 L8,18 L8,16 Z M20,20 L22,20 L22,22 L20,22 L20,20 Z M16,20 L18,20 L18,22 L16,22 L16,20 Z M12,20 L14,20 L14,22 L12,22 L12,
            20 Z M8,20 L10,20 L10,22 L8,22 L8,20 Z M4,20 L6,20 L6,22 L4,22 L4,20 Z M20,8 L22,8 L22,10 L20,10 L20,8 Z M16,8 L18,8 L18,
            10 L16,10 L16,8 Z M20,4 L22,4 L22,6 L20,6 L20,4 Z"></path>
        </g>
    </svg>
    `,
    list: `
    <svg viewBox="0 0 24 24">
        <g>
            <path d="M8,9 L8,5 L21,5 L21,9 L8,9 Z M3,5 L7,5 L7,9 L3,9 L3,5 Z M8,14 L8,10 L21,10 L21,14 L8,14 Z M3,10 L7,10 L7,
            14 L3,14 L3,10 Z M8,19 L8,15 L21,15 L21,19 L8,19 Z M3,15 L7,15 L7,19 L3,19 L3,15 Z"></path>
        </g>
    </svg>
    `,
    bottomArrow: `
    <svg viewBox="0 0 21.825 21.825">
        <path d="M16.791,13.254c0.444-0.444,1.143-0.444,1.587,0c0.429,0.444,0.429,1.143,0,1.587l-6.65,6.651
        c-0.206,0.206-0.492,0.333-0.809,0.333c-0.317,0-0.603-0.127-0.81-0.333l-6.65-6.651c-0.444-0.444-0.444-1.143,0-1.587
        s1.143-0.444,1.587,0l4.746,4.762V1.111C9.791,0.492,10.299,0,10.918,0c0.619,0,1.111,0.492,1.111,1.111v16.904L16.791,13.254z"/>
    </svg>
    `,
    wallet: `
    <svg viewBox="0 0 24 24">
        <g>
            <path d="M4,5 L20,5 C21.1045695,5 22,5.8954305 22,7 L22,18 C22,19.1045695 21.1045695,20 20,20 L4,20 C2.8954305,20 2,
            19.1045695 2,18 L2,7 C2,5.8954305 2.8954305,5 4,5 Z M20,18 L20,7 L12,7 L12,18 L20,18 Z M13,10 L19,10 L19,11 L13,
            11 L13,10 Z M13,12 L19,12 L19,13 L13,13 L13,12 Z M13,14 L19,14 L19,15 L13,15 L13,14 Z"></path>
        </g>
        </svg>`,
    receipt: `
        <svg width="24px" height="24px" viewBox="0 0 384 512">
        <g>
        <path d="M358.4 3.2L320 48 265.6 3.2a15.9 15.9 0 0 0-19.2 0L192 48 137.6 3.2a15.9 15.9 0 0 0-19.2 0L64 48 25.6 3.2C15-4.7 0 2.8 0 16v480c0 13.2 15 20.7 25.6 12.8L64 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L192 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L320 464l38.4 44.8c10.5 7.9 25.6.4 25.6-12.8V16c0-13.2-15-20.7-25.6-12.8zM320 360c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16z"/>
        </g>
        </svg>`,
    posReports: `
        <svg width="24px" height="24px" viewBox="0 0 384 512">
        <g>
        <path d="M288 248v28c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm-12 72H108c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-28c0-6.6-5.4-12-12-12zm108-188.1V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h204.1C264.8 0 277 5.1 286 14.1L369.9 98c9 8.9 14.1 21.2 14.1 33.9zm-128-80V128h76.1L256 51.9zM336 464V176H232c-13.3 0-24-10.7-24-24V48H48v416h288z"/>
        </g>
        </svg>`,
    balancing: `
        <svg width="24px" height="24px" viewBox="0 0 640 512">
        <g>
        <path d="M256 336h-.02c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0C-2.06 328.75.02 320.33.02 336H0c0 44.18 57.31 80 128 80s128-35.82 128-80zM128 176l72 144H56l72-144zm511.98 160c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 320l72-144 72 144H440zm88 128H352V153.25c23.51-10.29 41.16-31.48 46.39-57.25H528c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H383.64C369.04 12.68 346.09 0 320 0s-49.04 12.68-63.64 32H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h129.61c5.23 25.76 22.87 46.96 46.39 57.25V448H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"/>
        </g>
        </svg>`,
    cashier: `
        <svg width="24px" height="24px" viewBox="0 0 640 512">
        <g>
        <path d="M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"/>
        </g>
        </svg>`,
    store: `
        <svg width="24px" height="24px" viewBox="0 0 448 512">
        <g>
        <path d="M128 148v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12zm140 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-128 96h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm128 0h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-76 84v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm76 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm180 124v36H0v-36c0-6.6 5.4-12 12-12h19.5V24c0-13.3 10.7-24 24-24h337c13.3 0 24 10.7 24 24v440H436c6.6 0 12 5.4 12 12zM79.5 463H192v-67c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v67h112.5V49L80 48l-.5 415z"/>
        </g>
        </svg>`,
    terminal: `
        <svg width="24px" height="24px" viewBox="0 0 576 512">
        <g>
        <path d="M528 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h192l-16 48h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72l-16-48h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 352H64V64h448v288z"/>
        </g>
        </svg>`
};
